import { subdomains } from "@/common/consts";
import ReferenceHome from "@/pages/Reference/Home/ReferenceHome.vue";
import ReferenceDetail from "@/pages/Reference/Detail/ReferenceDetail.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        name: "ReferenceHome",
        meta: {
            subdomain: subdomains.REFERENCE
        },
        component: ReferenceHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/*",
        name: "ReferenceDetail",
        meta: {
            subdomain: subdomains.REFERENCE
        },
        component: ReferenceDetail
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.reference.js